export default {
  all (context) {
    let params = {
      page: context.page,
      order: context.order
    }
    context.loading = true
    context.$http.get('activity_logs', {params: params}).then(response => {
      context.activityLogs = response.body.data
      context.pagination = response.body.metadata.pagination
      context.loading = false
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/activityLogs.js